/* iArena search.
   Results page: Shopify ORs the words of a query and applies typo tolerance, so "dolche" also returns Dolly and
   Dulce and "Briana Grey" returns every grey product. Quoting a word makes Shopify require that exact token, so
   on submit every alphabetic word is quoted; codes with digits (SKUs) stay as typed because quoting breaks them.
   Quoted phrases and field/operator syntax pass through untouched. The search page falls back to the loose
   search when the strict one finds nothing.
   Dropdown: the theme renders Shopify's fuzzy predictive results; they are filtered so that only titles in which
   every typed word starts a word remain (prefix match, no typo tolerance). */
(function () {
  function strict(v) {
    v = (v || '').trim();
    if (!v || v.indexOf('"') > -1 || v.indexOf(':') > -1 || /(^|\s)[-+]\S/.test(v)) return v;
    var words = v.split(/\s+/).filter(function (t) { return /[A-Za-z0-9Ѐ-ӿ]/.test(t); });
    if (!words.length) return v;
    return words.map(function (t) { return /\d/.test(t) ? t : '"' + t + '"'; }).join(' ');
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('search-form')) return;
    var input = f.querySelector('[data-search-input]');
    if (input) input.value = strict(input.value);
  }, true);
  window.arenaStrictSearch = strict;

  // ---- dropdown filter
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9Ѐ-ӿ]+/g, ' ').trim(); }
  function matches(title, terms) {
    var words = norm(title).split(' ');
    return terms.every(function (t) { return words.some(function (w) { return w.indexOf(t) === 0; }); });
  }
  function filter(form) {
    var input = form.querySelector('[data-search-input]'); if (!input) return;
    var terms = norm(input.value).split(' ').filter(Boolean); if (!terms.length) return;
    var items = form.querySelectorAll('.predictive-search__product-suggestion'); if (!items.length) return;
    var kept = 0;
    items.forEach(function (li) {
      var t = li.querySelector('.predictive-search__product-suggestion-title');
      var ok = matches(t ? t.textContent : li.textContent, terms);
      li.hidden = !ok; if (ok) kept++;
    });
    var col = items[0].closest('.predictive-search__main-column');
    if (col) {
      var note = col.querySelector('.ar-ps-none');
      if (!kept) {
        if (!note) { note = document.createElement('p'); note.className = 'predictive-search__no-results ar-ps-none'; note.textContent = 'Няма точно съвпадение за „' + input.value.trim() + '“.'; col.appendChild(note); }
        else note.textContent = 'Няма точно съвпадение за „' + input.value.trim() + '“.';
      } else if (note) note.remove();
    }
  }
  document.querySelectorAll('form.search-form [data-search-results]').forEach(function (box) {
    var form = box.closest('form');
    new MutationObserver(function () { filter(form); }).observe(box, { childList: true, subtree: false });
  });
})();
